module.exports = __webpack_public_path__ + "img/img_nav_cooperate_hover.3bef02e2.svg";